import { render, staticRenderFns } from "./LearningUnitCategoriesSelector.vue?vue&type=template&id=164b5a02&scoped=true&"
import script from "./LearningUnitCategoriesSelector.vue?vue&type=script&lang=js&"
export * from "./LearningUnitCategoriesSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164b5a02",
  null
  
)

export default component.exports